<template>
  <b-table
    :fields="fields"
    :items="teamDonationsList"
    caption-top
    stacked="lg"
    hover
    small
    head-variant="light"
    responsive="sm"
    class="text-center team-table"
    :busy="loading"
  >
    <template #table-busy>
      <div class="text-center my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong class="mx-2">Loading...</strong>
      </div>
    </template>
    <template v-slot:head(id)>
      <div>{{ $t("dashboard.donation_id", "DID") }}</div>
    </template>
    <template v-slot:head(date)>
      <div>{{ $t("dashboard.donation_date", "Date") }}</div>
    </template>
    <template v-slot:head(name)>
      <div>{{ $t("dashboard.donation_name", "Name") }}</div>
    </template>
    <template v-slot:head(display_name)>
      <div>{{ $t("dashboard.donation_display_name", "Display Name") }}</div>
    </template>
    <template v-slot:head(charged_amount)>
      <div>{{ $t("dashboard.donation_amount_charged", "Real Amount") }}</div>
    </template>
    <template v-slot:head(effective_amount)>
      <div>{{ $t("dashboard.donation_amount_effective", "Total Amount") }}</div>
    </template>
    <template v-slot:head(email)>
      <div>{{ $t("dashboard.donation_email", "Email") }}</div>
    </template>
    <template v-slot:head(phone)>
      <div>{{ $t("dashboard.donation_phone", "Phone") }}</div>
    </template>

    <template v-slot:cell(id)="{ item }">
      <div>{{ item.id }}</div>
    </template>
    <template v-slot:cell(date)="{ item }">
      <div>{{ getDateFormat(item.attributes.date) }}</div>
    </template>
    <template v-slot:cell(name)="{ item }">
      <div>{{ item.attributes.billing_name }} {{ item.attributes.billing_last_name }}</div>
    </template>
    <template v-slot:cell(display_name)="{ item }">
      <div>{{ item.attributes.display_name }}</div>
    </template>
    <template v-slot:cell(charged_amount)="{ item }">
      <div>{{ campaignCurrencySign }} {{ item.attributes.charged_amount }}</div>
    </template>
    <template v-slot:cell(effective_amount)="{ item }">
      <div>{{ campaignCurrencySign }} {{ item.attributes.effective_amount }}</div>
    </template>
    <template v-slot:cell(email)="{ item }">
      <div>{{ item.attributes.email }}</div>
    </template>
    <template v-slot:cell(phone)="{ item }">
      <div>{{ item.attributes.phone }}</div>
    </template>
  </b-table>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import urls from "@/constants/urls";
import axios from "axios";

export default {
  props: {
    teamId: {
      type: [Number, String],
      default: 0,
    },
    status: {
      type: String,
      default: "processed-without-recurring-type",
    },
  },
  data() {
    return {
      fields: [
        "id",
        "date",
        "name",
        "display_name",
        "charged_amount",
        "effective_amount",
        "email",
        "phone",
      ],
      loading: false,
      donationTotal: 0,
      teamDonationsList: [],
    };
  },
  watch: {
    loading() {
      this.$emit("loading", this.loading);
    },
    teamDonationsList() {
      const data = {
        list: this.teamDonationsList,
        loading: this.loading,
        total: this.donationTotal,
      };
      this.$emit("data", data);
    },
  },
  computed: {
    ...mapState({
      campaignId: (state) => state.dashboard.selectedCampaign,
      campaignCurrencySign: (state) => state.campaign.campaign.data.attributes.currency_sign,
    }),
    orgId() {
      return localStorage.getItem("orgId");
    },
  },
  mounted() {
    this.getDonation();
  },
  methods: {
    getDonation() {
      this.loading = true;
      this.teamDonationsList = [];
      const params = {
        team_id: this.teamId,
        status: this.status,
      };
      axios
        .get(
          urls.donationNewApi.replace(":orgId", this.orgId).replace(":campaignId", this.campaignId),
          { params }
        )
        .then((response) => {
          this.teamDonationsList = response.data.data;
          this.donationTotal = response.headers["x-search-donations"];
        })
        .catch((error) => {
          console.error("Error fetching donations:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDateFormat: function (date) {
      let donateDate = moment.unix(date).format("MMMM D, YYYY");

      let thisDate = moment(new Date()).format("MMMM D, YYYY");

      if (donateDate == thisDate) {
        return moment.unix(date).format("h:mm a");
      } else {
        return moment.unix(date).format("MMMM D, YYYY h:mm a");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.no-data {
  min-height: 64px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
#collapse-icon {
  transition: transform 0.2s cubic-bezier(0.23, 1, 0.32, 1);
}
.rotate-180 {
  transition: transform 0.2s cubic-bezier(0.23, 1, 0.32, 1);
  stroke: #107598;
  transform: rotate(180deg);
}
</style>
